module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2RcCz"))).then(() => parcelRequire('1iHdE'));